// import { HttpInboundBillClientList } from '@/service/inbound';
import { HttpGetStaffList } from '@/service/department/departmentmanage.js'
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    props:['selectDeptId','type'],
    data() {
        return {
            isMixin: true,
            Tabs: { show: true },
            formData: {
                search: {
                },
                deptId: ''
            },
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
        };
    },
    watch: {
        'selectDeptId': {
            immediate: true,
            handler (val) {
                this.formData.deptId = val
            }
        }
    },
    methods: {
        ajaxRequest: HttpGetStaffList,
        interceptRequest(params) {
            params.name = params.search.name
            params.mail = params.search.mail
            params.phone = params.search.phone
            delete params.search.name
            delete params.search.mail
            delete params.search.phone

            return params
        },
        handleOperates(data) {
            this.$emit('on-data', data)
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCusproductList', 'getBillcusWareList']),
        SearchsData() {
            return [
                {
                    label: "姓名",
                    key: 'name',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "电话",
                    key: 'phone',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "邮箱",
                    key: 'mail',
                    show: true,
                    tag: 'vInput',
                },
            ]
        },
        columns() {
            return [
                {
                    title: "姓名",
                    key: 'name',
                },
                {
                    title: "电话",
                    key: 'phone',
                },
                {
                    title: "邮箱",
                    key: 'email',
                },
                {
                    title: "工号",
                    key: 'workno',
                },
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 90,
                    align: 'center',
                    render: (h, { row }) => {
                        return <vButton theme='primary' onClick={this.handleOperates.bind(this, row)}>{this.$t('fbb.inbound.choose', { defaultValue: '选择' })}</vButton>
                    }
                }];
        },
    },
};




